import { z } from 'zod';
import { userSchema } from './user.schemas';
import { componentTypeSchema } from './component-base.schemas';
import { componentSchema } from './component-union.schemas';

// API request schemas
export const addComponentRequestSchema = z.object({
  component: z.object({
    type: componentTypeSchema,
    data: z.record(z.any()),
    visible: z.boolean().optional(),
  }),
  position: z.number().int().min(0).optional(),
});

export const updateComponentRequestSchema = z.object({
  updates: z.object({
    data: z.record(z.any()).optional(),
    visible: z.boolean().optional(),
    order: z.number().int().min(0).optional(),
  }),
});

export const reorderComponentsRequestSchema = z.object({
  componentOrders: z.array(
    z.object({
      componentId: z.string().uuid(),
      order: z.number().int().min(0),
    })
  ),
});

// API Response schemas
export const authResponseSchema = z.object({
  token: z.string(),
  user: userSchema,
  /** Present on signup. Missing means the verification email was sent. */
  verificationEmailSent: z.boolean().optional(),
});

export const errorResponseSchema = z.object({
  error: z.string(),
});

export const componentResponseSchema = z.object({
  pageId: z.string().uuid(),
  components: z.array(componentSchema),
  metadata: z.object({
    version: z.string(),
    lastModified: z.string().datetime(),
    totalComponents: z.number().int().min(0),
  }),
});

// Type exports
export type AddComponentRequest = z.infer<typeof addComponentRequestSchema>;
export type UpdateComponentRequest = z.infer<typeof updateComponentRequestSchema>;
export type ReorderComponentsRequest = z.infer<typeof reorderComponentsRequestSchema>;
export type AuthResponse = z.infer<typeof authResponseSchema>;
export type ErrorResponse = z.infer<typeof errorResponseSchema>;
export type ComponentResponse = z.infer<typeof componentResponseSchema>;
